// api.js: switch between mock API and remote API based on environment
import mockApi from "./mockApi";

let api = mockApi;
// In tests we always force the mock API to avoid bundler/Jest ESM issues
// and to keep unit tests deterministic.
if (process.env.NODE_ENV !== "test" && process.env.REACT_APP_BACKEND_URL) {
  // lazy load remoteApi to avoid importing axios in test environments
  // eslint-disable-next-line global-require, import/no-dynamic-require
  const remoteApi = require("./remoteApi").default;
  api = remoteApi;
}

export default api;
